<template>
  <div class="password tc">
      <h2>请输入支付验证码</h2>
      <p>接收手机号码：{{infos.desensitizedPhone}}</p>
       <van-password-input
        :value="password"
        :mask="false"
        :focused="showKeyboard"
        gutter='10px'
        @focus="showKeyboard = true"
        />

        <div class="get-code" @click="getCode">重新获取 {{counts ? '('+counts+'s)' : ''}}</div>
        <!-- 数字键盘 -->
        <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        />

  </div>
</template>

<script>

import {vipPaySmsCheck,sendSmsAgain} from '@/api/members'

export default {
  name: 'plusPassword',
  data() { 
    return {
        password: '',
        showKeyboard: false,
        counts:null,
        infos:null
    }
  },
  watch:{
    password(value) {
      if (value.length === 6) {
         this.verfiyCode()
          
        // this.errorInfo = '密码错误';
      } else {
        // this.errorInfo = '';
      }

    },
  },
  beforeRouteEnter(to, from, next) {
      if(from.name === 'servicesBuy'){
        next(vm => {
          vm.timer()
        })
      }
      next()
  },  
  
  created(){
    this.infos = JSON.parse(decodeURIComponent(this.$route.query.infos))
  },
  methods:{
      verfiyCode(){
         this.$toast.loading({
            message: '正在支付，请稍等...',
            forbidClick: true,
            duration:0
          });
        const prams={
          orderNo:this.infos.orderNo ,
          code:this.password
        }
        let h5 = this.infos.payResultMsg && JSON.parse(this.infos.payResultMsg)
        vipPaySmsCheck(prams).then(res=>{
           this.$toast.clear()
            if(!res.code){
              if(h5) return window.location.href=h5.h5_url

              this.$toast(res.message)
              this.$router.push({name:'plusResult',query:{outTradeNo:this.infos.orderNo}})
            }
        })
      },
      getCode(){
          if(this.counts) return this.$toast('请不要重复获取验证码！')
          sendSmsAgain({vipOrderNo:this.infos.orderNo}).then(reg=>{
            if(!reg.code){
                this.timer()
            }
          })


      },
      /* 倒计时*/ 
      timer(){
        const TIME_COUNT = 60 
        let timer = null
        if (!timer) {
            this.counts = TIME_COUNT
            // this.showCode = false
            timer = setInterval(() => {
            if (this.counts > 0 && this.counts <= TIME_COUNT) {
                this.counts--
            } else {
                // this.showCode = true
                clearInterval(timer)
                timer = null
                }
            }, 1000)
        }
        },
  }
 }
</script>

<style lang="scss" scoped>
  .password{
      padding: 45px 0;

      h2{
          font-size: 20px;
          color:#111111 ;
      }
      p{
          font-size: 15px;
          color: #46474B;
          margin-top: 18px;
          margin-bottom: 45px;
      }
      .get-code{
          color: #4A549E;
          margin-top: 16px;

          i{
              font-style: normal;
          }
      }
      .van-password-input__security li{
          background:#F5F5F7  !important;
          border-radius: 8px !important;
      }
  }
</style>